import { LocalstorageService } from "../service/shared/localstorage/localstorage.service";

/**
 * Component that invokes this function MUST inherit the localStorageService.
 */
export default function getAndParseUserPermissions(service: LocalstorageService) {
  const val = JSON.parse(service.getItem('user'));
  return JSON.parse(val['permissions']);
}
